// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dropdown_dropdown__PHdgV svg,
.Dropdown_dropdown-institution__7-b1N svg {
  cursor: pointer;
  width: 30px;
  height: 30px;
}
.Dropdown_dropdown__PHdgV svg path,
.Dropdown_dropdown-institution__7-b1N svg path {
  stroke-width: 0.5px;
}

.Dropdown_dropdown-institution__7-b1N svg path {
  stroke: white;
  stroke-width: 1px;
}

.Dropdown_logout-button__9JG0A {
  display: flex;
  align-items: center;
}
.Dropdown_logout-button__9JG0A svg {
  margin-right: 10px;
}
.Dropdown_logout-button__9JG0A svg path {
  stroke: red;
}

.Dropdown_login-button__0SuW1 {
  display: flex;
  align-items: center;
}
.Dropdown_login-button__0SuW1 svg {
  margin-right: 10px;
}
.Dropdown_login-button__0SuW1 svg path {
  stroke: green;
}

.Dropdown_other-services__rvU\\+f {
  text-decoration: none;
  display: flex;
  align-items: center;
}
.Dropdown_other-services__rvU\\+f svg {
  margin-right: 10px;
}

.Dropdown_login-modal__L5mUK {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Layout/Navbar/Components/Dropdown/Dropdown.module.scss"],"names":[],"mappings":"AAEE;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAAJ;AACI;;EACE,mBAAA;AAEN;;AAII;EACE,aAAA;EACA,iBAAA;AADN;;AAKA;EACE,aAAA;EACA,mBAAA;AAFF;AAGE;EACE,kBAAA;AADJ;AAEI;EACE,WAAA;AAAN;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;AAEE;EACE,kBAAA;AAAJ;AACI;EACE,aAAA;AACN;;AAIA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;AADF;AAEE;EACE,kBAAA;AAAJ;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAAF","sourcesContent":[".dropdown,\n.dropdown-institution {\n  svg {\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    path {\n      stroke-width: 0.5px;\n    }\n  }\n}\n.dropdown-institution {\n  svg {\n    path {\n      stroke: white;\n      stroke-width: 1px;\n    }\n  }\n}\n.logout-button {\n  display: flex;\n  align-items: center;\n  svg {\n    margin-right: 10px;\n    path {\n      stroke: red;\n    }\n  }\n}\n.login-button {\n  display: flex;\n  align-items: center;\n  svg {\n    margin-right: 10px;\n    path {\n      stroke: green;\n    }\n  }\n}\n\n.other-services {\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  svg {\n    margin-right: 10px;\n  }\n}\n.login-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `Dropdown_dropdown__PHdgV`,
	"dropdown-institution": `Dropdown_dropdown-institution__7-b1N`,
	"logout-button": `Dropdown_logout-button__9JG0A`,
	"login-button": `Dropdown_login-button__0SuW1`,
	"other-services": `Dropdown_other-services__rvU+f`,
	"login-modal": `Dropdown_login-modal__L5mUK`
};
export default ___CSS_LOADER_EXPORT___;
